<template>
    <div>
        <div class="d-flex">
            <SelectAsync
                ref="selectSimpleFilterFiles"
                :placeholder="$t('Select a file')"
                :optionsValue="'uuid'"
                :optionsLabel="(item)=> item.file_name"
                :resetOption="true"
                size="sm"
                :value.sync="valueComponent"
                endpoint="/imports/simple-filter-files"
                matchResponseItems="data.items"
                :fetchConfig="{
                    baseURL: ApiSass,
                }" 
            />
            <CButton
                @click="modals.uploadSimpleFilterFile.show = true"
                size="sm"
                ><CIcon :content="$options.icons.cilPlus"
            /></CButton>
        </div>
        <CCModalUploadSimpleFilterFile
            :show.sync="modals.uploadSimpleFilterFile.show"
            @uploadedFile="uploadFile"
            color="primary"
            size="lg"
            :title="$t('Upload Simple Filter File')"
        >
        </CCModalUploadSimpleFilterFile>
    </div>
</template>

<script>
import baseMixin from "@/mixins/base";
import SelectAsync from "~/components/elements/SelectAsync";
import CCButtonUploadFile from "~/components/CCButtonUploadFile";

import CCModalUploadSimpleFilterFile from "~/components/CCModalUploadSimpleFilterFile";
import { cilPlus } from "@coreui/icons";
export default {
    name: "CCUploadSimpleFilterFile",
    mixins: [baseMixin],
    icons: {
        cilPlus,
    },
    components: {
        SelectAsync,
        CCButtonUploadFile,
        CCModalUploadSimpleFilterFile,
    },
    data() {
        return {
            valueComponent: null,

            modals: {
                uploadSimpleFilterFile: {
                    show: false,
                    data: {},
                },
            },
        };
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: "md",
        },
        value: {
            default: null,
        },
    },
    watch: {
        value(newValue) {
            this.valueComponent = newValue;
        },
        valueComponent(newValue) {
            this.$emit("update:value", newValue);
        },
    },
    methods: {
        async uploadFile({ key }) {
            const refSelectSimpleFilterFiles =
                this.$refs["selectSimpleFilterFiles"];
            await refSelectSimpleFilterFiles.reload();

            this.valueComponent = key;
        },
    },
    async mounted() {
        this.valueComponent = this.value;
    },
};
</script>
